import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Chip } from '../../components/chips/Chip';
import {
  ABROGE_DIFF,
  VIGUEUR_DIFF,
  MODIFIE,
  ABROGE,
} from '../../../../shared/constants/legislationArticleApplicability';
import { LegislationPopoverInfos } from '../legislation.types';

type Props = {
  legislation: LegislationPopoverInfos;
};

export const LegislationCardVersionChipSelection: FC<Props> = ({
  legislation: { applicability, isLatestVersion },
}) => {
  if (applicability === ABROGE_DIFF) {
    return (
      <Chip data-test-id="legislation-chip-applicable-diff" color="success">
        <FormattedMessage id="legislation/components/card/LegislationCardVersionChipSelection.tsx/2" />
      </Chip>
    );
  }
  if (applicability === VIGUEUR_DIFF) {
    return (
      <Chip data-test-id="legislation-chip-future" color="future">
        <FormattedMessage id="legislation/components/card/LegislationCardVersionChipSelection.tsx/3" />
      </Chip>
    );
  }
  if (applicability === ABROGE && isLatestVersion) {
    return (
      <Chip data-test-id="legislation-chip-abrogated" color="warning">
        <FormattedMessage id="legislation/components/card/LegislationCardVersionChipSelection.tsx/4" />
      </Chip>
    );
  }
  if (applicability === MODIFIE || !isLatestVersion) {
    return (
      <Chip data-test-id="legislation-chip-former" color="warning">
        <FormattedMessage id="legislation/components/card/LegislationCardVersionChipSelection.tsx/5" />
      </Chip>
    );
  }
  return null;
};
